var React = require('react');

function ButtonCross (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#fff;stroke-width:1;stroke-linecap:round;}\n"),React.createElement("line",{"className":"st0","x1":"8.2","y1":"0.8","x2":"0.8","y2":"8.2","key":1}),React.createElement("line",{"className":"st0","x1":"0.8","y1":"0.8","x2":"8.2","y2":"8.2","key":2})]);
}

ButtonCross.defaultProps = {"version":"1.1","id":"cross","x":"0px","y":"0px","viewBox":"0 0 9 9","style":{"enableBackground":"new 0 0 9 9"},"xmlSpace":"preserve"};

module.exports = ButtonCross;

ButtonCross.default = ButtonCross;
